import { AppBar, Box, Chip, Toolbar, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import { checkDev, getEnv } from '../config';
import { envBadge } from '../utils/envBadge';
import { pageTitle } from '../utils/page';
import { HideLeftButton } from './Button/HideLeftButton';
import { MenuButton } from './Button/MenuButton';
import { RefreshSettingsButton } from './Button/RefreshSettingsButton';
import { navWidth } from './Navbar/Navbar';

const badge = envBadge(getEnv(), checkDev());

export const Header = ({ brand, isOpen, handleToggle }) => {
	const navigate = useNavigate();
	const { pathname } = useLocation();
	return (
		<AppBar
			position="fixed"
			sx={isOpen ? { width: { md: `calc(100% - ${navWidth}px)` }, ml: { md: `${navWidth}px` } } : {}}
		>
			<Toolbar sx={{ position: 'relative' }}>
				{isOpen ? <HideLeftButton handleClick={handleToggle} /> : <MenuButton handleClick={handleToggle} />}
				<Typography variant="h6" onClick={() => navigate('')} sx={{ cursor: 'pointer' }}>
					{brand}
				</Typography>
				<Chip label={badge.label} color={badge.color} size="small" sx={{ ml: 1.5, fontWeight: 700 }} />
				<Typography
					variant="h6"
					sx={{
						textAlign: 'end',
						position: { md: 'absolute' },
						left: { md: '50%' },
						transform: { md: 'translateX(-50%)' },
					}}
				>
					{pageTitle(pathname)}
				</Typography>
				<Box sx={{ ml: 'auto' }}>
					<RefreshSettingsButton />
				</Box>
			</Toolbar>
		</AppBar>
	);
};

Header.propTypes = {
	brand: PropTypes.string,
	isOpen: PropTypes.bool,
	handleToggle: PropTypes.func,
};
